import React, { Component } from 'react';
import _ from 'lodash';
import Axios from '../request';

import { Flex, Loading } from '../components';
import request from '../../../request';

export const Service = {
  taskInProgressing: 'ws.onboardingProcess.task.taskInProgressing',
  taskCompleted: 'ws.onboardingProcess.task.taskCompleted',
};

class ConnectorIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingPage: true,
      microserviceUrl: '',
      microserviceStatus: '',
    };
    this.receiver = this.receiver.bind(this);
  }

  componentDidMount() {
    window.removeEventListener('message', this.receiver, false);
    window.addEventListener('message', this.receiver, false);
    this.fetchConnectorUrl().then((response) => {
      const {
        microservice_url: microserviceUrl,
        microservice_status: microserviceStatus,
        preview_url: previewUrl,
      } = response.data;
      this.setState({
        microserviceUrl: microserviceUrl || previewUrl,
        microserviceStatus,
      });
    });
  }

  fetchConnectorUrl() {
    const { action, companyStaff, previewMode } = this.props;
    const actionUUID = action.uuid;
    if (actionUUID) {
      let getConnectorActionAPI = `${APIHOST}/v1/onboarding/microservices/employee/employee_onboarding_actions/${actionUUID}`;
      const companyId = new URLSearchParams(location.search).get('companyId');
      const headers = {
        ...(authCode && { Authorization: authCode }),
        ...(companyId && { 'ws-company-id': companyId }),
      };
      if (companyStaff && companyStaff.id) {
        getConnectorActionAPI = `${APIHOST}/v1/onboarding/microservices/hr/employee_onboarding_actions/${actionUUID}`;
      }
      if (previewMode) {
        getConnectorActionAPI = `${APIHOST}/v1/onboarding/microservices/hr/company_onboarding_actions/${actionUUID}/preview`;
      }
      return request('GET', getConnectorActionAPI, {}, headers);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiver, false);
  }

  markAsComplete() {
    const { action, onSubmitFormSuccess } = this.props;
    const { APIHOST, authCode } = window;
    const digestKey = action.digest_key;
    const apiURL = `${APIHOST}/v1/onboarding/employee/employee_onboarding_actions/${digestKey}/completed`;
    const config = {
      method: 'PUT',
      url: apiURL,
      headers: {
        ...(authCode && { Authorization: authCode }),
      },
    };
    Axios(config).then(() => {
      onSubmitFormSuccess();
    }).catch((error) => {
      if (error && error.response && error.response.data) {
        const { error_code: errorCode, message } = error.response.data;
        if (errorCode === 43002) {
          // Bypass the expected error.
          onSubmitFormSuccess();
        } else {
          alert(message);
        }
      }
    });
  }

  receiver(event) {
    let data = null;
    try {
      data = JSON.parse(event.data);
      const { service } = data;
      switch (service) {
        case Service.taskInProgressing:
          // Todo: need to check with Ryan about API
          break;
        case Service.taskCompleted:
          this.markAsComplete();
          break;
        default:
          break;
      }
    } catch (error) {
      // error
    }
  }

  render() {
    const { action } = this.props;
    const { name: actionName } = action;
    const { microserviceUrl, microserviceStatus } = this.state;
    const { isLoadingPage } = this.state;

    if (microserviceStatus === 'unhealthy') {
      return (
        <Flex column alignItems="center" justifyContent="center">
          <Flex column mt={[50, 0]} ml={[0, 123]}>
            <Text mt={1}>{`Currently ${actionName} is not available. Please try it later`}</Text>
          </Flex>
        </Flex>
      );
    }

    return (
      <Flex>
        {isLoadingPage && <Loading className="spinner spinner-blue" />}
        {microserviceUrl && (
          <iframe
            id="microservice-page"
            onLoad={() => {
              this.setState({ isLoadingPage: false });
            }}
            src={microserviceUrl}
            style={{
              border: 'none', height: '700px', display: 'block', width: '100%', minHeight: '530px',
            }}
          />
        )}
      </Flex>
    );
  }
}

export default ConnectorIframe;
